import { forwardRef } from "react";
import { Logout, UserMenu, useTranslate, useUserMenu } from "react-admin";
import { MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import PasswordIcon from "@mui/icons-material/Password";
import VpnKeyIcon from "@mui/icons-material/VpnKey";

// It's important to pass the ref to allow Material UI to manage the keyboard navigation
const SettingsMenuItem = forwardRef(({ setOpen, ...props }, ref) => {
  // We are not using MenuItemLink so we retrieve the onClose function from the UserContext
  const { onClose } = useUserMenu();
  const t = useTranslate();

  const handleClick = () => {
    onClose();
    setOpen(true);
  };

  return (
    <MenuItem
      onClick={handleClick}
      ref={ref}
      // It's important to pass the props to allow Material UI to manage the keyboard navigation
      {...props}
    >
      <ListItemIcon>
        <VpnKeyIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>{t("mine.label.change_password")}</ListItemText>
    </MenuItem>
  );
});

const CustomUserMenu = ({ setOpen }) => {
  return (
    <UserMenu>
      <SettingsMenuItem setOpen={setOpen} />
      <Logout />
    </UserMenu>
  );
};

export default CustomUserMenu;
